var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppBar',{on:{"drawer":function($event){_vm.drawer = !_vm.drawer}}}),_c('NavigationDrawer',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('v-main',[_c('router-view')],1),_c('NotificationBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }